import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';

/* eslint-disable @typescript-eslint/no-explicit-any */
class AnalyticsService {
    constructor() {
        this.systemPrefix = '007'; // Event prefix for Titan systems
    }
    storeHeartbeatEvent(events = []) {
        this.heartbeatEvents = events;
    }
    getHeartbeatEvent() {
        return this.heartbeatEvents;
    }
    clearHeartbeatEvents() {
        this.heartbeatEvents = [];
    }
    init() {
        this.storeHeartbeatEvent();
        this.pageTrack();
    }
    sendToGA(event) {
        ga('send', 'event', {
            eventCategory: event.category,
            eventAction: event.action,
            eventLabel: `${event.code}:${event.label}`,
            eventValue: event.value,
            eventDescription: event.description,
            eventUser: event.user,
            eventWidgetId: event.widgetId,
        });
    }
    createHeartbeatEvent(event) {
        const heartbeat = {
            code: `${this.systemPrefix}-${event.code}`,
            data: {
                body: event.description || event.category,
                type: event.action,
            },
        };
        if (event.widgetId) {
            heartbeat.widget = {
                id: event.widgetId,
            };
        }
        const state = this.getHeartbeatEvent() || [];
        this.storeHeartbeatEvent(state.concat(heartbeat));
    }
    eventTrack(event) {
        this.sendToGA(event);
        this.createHeartbeatEvent(event);
    }
    pullHearbeatEvents() {
        return this.getHeartbeatEvent();
    }
    pageTrack(route) {
        ga('send', 'pageview', route);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: AnalyticsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: AnalyticsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: AnalyticsService, decorators: [{
            type: Injectable
        }] });

class AnalyticsModule {
    static forRoot() {
        return {
            ngModule: AnalyticsModule,
            providers: [AnalyticsModule],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: AnalyticsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.2", ngImport: i0, type: AnalyticsModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: AnalyticsModule, providers: [AnalyticsService] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: AnalyticsModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [AnalyticsService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AnalyticsModule, AnalyticsService };
